import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  delete: {
    id: 'studio.ZMqEzX',
    defaultMessage: 'Delete app collection',
  },
  edit: {
    id: 'studio.R7tRYh',
    defaultMessage: 'Edit app collection',
  },
});
